
<div #shopFilter class="shop_filter_content" [class.open]="this.isOpened">
    <div class="shop_filter" (click)="this.openDropdown()">
        <div class="shop_filter_value">{{this.labelValue}}</div>
        @if(this.isOpened){
            <ion-icon class="shop_filter_icon" name="chevron-up-outline"></ion-icon>
        }
        @else{
            <ion-icon class="shop_filter_icon" name="chevron-down-outline"></ion-icon>
        }
    </div>
    <div class="shop_filter_dropdown">
        <div class="shop_filter_dropdown_option" (click)="this.displayAll()">{{'SHOP.FILTER_DISPLAY_ALL' | translate}}</div>
        
        <div class="shop_filter_dropdown_options">            
            @for(item of this.itemsCopy; track $index){
                <div 
                    class="shop_filter_dropdown_option" 
                    [class.selected]="item.selected"
                    (click)="this.toggleItem(item)"
                    >
                    @if(item.selected){
                        <ion-icon class="shop_filter_icon" name="checkbox-outline"></ion-icon>
                    }
                    @else{
                        <ion-icon class="shop_filter_icon" name="square-outline"></ion-icon>
                    }
                    <div class="shop_filter_dropdown_option_label">{{item.label}}</div>
                </div>
            }            
        </div>
    </div>
</div>